import React from 'react';
import { Button } from '../ui';

const FORM_VARIANT_MAP = {
    primary: 'primary',
    secondary: 'neutral',
    ghost: 'neutral',
    danger: 'danger',
};

const SIZE_MAP = {
    sm: 'sm',
    md: 'md',
    lg: 'md',
};

const FormButton = ({
    variant = 'primary',
    size = 'md',
    children,
    onClick,
    type = 'button',
    loading = false,
    disabled = false,
    icon,
    fullWidth = false,
    className = '',
    ariaLabel,
    emphasis = variant === 'primary',
}) => (
    <Button
        type={type}
        variant={FORM_VARIANT_MAP[variant] || 'primary'}
        size={SIZE_MAP[size] || 'md'}
        loading={loading}
        disabled={disabled}
        fullWidth={fullWidth}
        emphasis={emphasis && variant === 'primary'}
        className={className}
        onClick={onClick}
        aria-label={ariaLabel}
        icon={icon}
    >
        {children}
    </Button>
);

export default FormButton;
